export const defaultButtonStyle = {
  borderRadius: 2,
  textTransform: "none",
};

export const chooseButtonStyle = {
  borderRadius: 4,
  textTransform: "none",
  // backgroundColor: "rgba(51, 65, 85, 1)",
  backgroundColor: "#EF7C4F",
  color: "white",
};

export const chooseButtonTurquoiseStyle = {
  borderRadius: 4,
  textTransform: "none",
  // backgroundColor: "rgba(51, 65, 85, 1)",
  backgroundColor: "#00C9DB",
  color: "#003C59",
};

export const chooseButtonStyleDark = {
  borderRadius: 4,
  textTransform: "none",
  backgroundColor: "#003C59",
  // backgroundColor: "rgba(255, 107, 53, 1)",
  color: "white",
};

export const altChooseButtonStyle = {
  borderRadius: 1,
  textTransform: "none",
  // backgroundColor: "rgba(51, 65, 85, 1)",
  // backgroundColor: "rgba(255, 107, 53, 1)",
  backgroundColor: "#EF7C4F",
  color: "white",
};

export const altChooseButtonStyleTurquoise = {
  borderRadius: 1,
  textTransform: "none",
  // backgroundColor: "rgba(51, 65, 85, 1)",
  // backgroundColor: "rgba(255, 107, 53, 1)",
  backgroundColor: "#00C9DB",
  color: '#003C59'
  // color: "white",
};

export const altCloseButtonStyleDark = {
    color: 'white',
  textTransform: "none",
    borderColor: 'rgba(255, 255, 255, 0.3)',
    '&:hover': {
        borderColor: 'white',
        backgroundColor: 'rgba(255, 255, 255, 0.1)'
    }
};

export const transparentButtonStyle = {
  borderRadius: 2,
  textTransform: "none",
  backgroundColor: "transparent",
  color: "rgb(30, 41, 59)",
  fontWeight: 'bold'
};

export const transparentButtonStyleWhitefont = {
  borderRadius: 2,
  textTransform: "none",
  backgroundColor: "transparent",
  fontWeight: 'bold'
};

export const transparentBlueButtonStyle = {
  borderRadius: 2,
  textTransform: "none",
  backgroundColor: "transparent",
  // color: "rgb(30, 41, 59)",
  fontWeight: 'bold'
};

export const transparentOrangeButtonStyle = {
  borderRadius: 2,
  textTransform: "none",
  backgroundColor: "transparent",
  color: "#EF7C4F",
  fontWeight: 'bold'
};

export const chooseInMobileButtonStyle = {
  width: '80%',
  // marginTop: 2,
  // marginBottom: 2,
};